export default "__VITE_ASSET___68w0Clx__"